(() => {
  const STORAGE_KEY = 'doapparel:collection_context_handle';
  const COOKIE_KEY = 'doapparel_collection_handle';

  function normalizePath(pathname) {
    if (!pathname) return '/';
    return pathname.replace(/\/+$/, '') || '/';
  }

  function getCollectionRootPath(pathname) {
    const match = normalizePath(pathname).match(/\/collections\/([^/?#]+)/);
    return match ? `/collections/${match[1]}` : '';
  }

  function isCollectionPath(pathname) {
    return /\/collections\/[^/]+/.test(pathname);
  }

  function isProductPath(pathname) {
    return /\/products\/[^/]+/.test(pathname);
  }

  function isAllowedPath(pathname) {
    if (isCollectionPath(pathname)) return true;
    if (isProductPath(pathname)) return true;
    if (/\/checkout(?:\/|$)/.test(pathname)) return true;
    return false;
  }

  function getStoredCollectionPath() {
    try {
      const storedPath = localStorage.getItem(STORAGE_KEY) || '';
      return getCollectionRootPath(storedPath) || storedPath;
    } catch (_) {
      return '';
    }
  }

  function getCollectionHandle(pathname) {
    const collectionPath = getCollectionRootPath(pathname);
    if (!collectionPath) return '';
    return collectionPath.split('/collections/')[1]?.split('/')[0] || '';
  }

  function setCollectionCookie(handle) {
    if (!handle) return;
    document.cookie = `${COOKIE_KEY}=${encodeURIComponent(handle)};path=/;max-age=31536000;SameSite=Lax`;
  }

  function setStoredCollectionPath(pathname) {
    const collectionPath = getCollectionRootPath(pathname);
    if (!collectionPath) return;

    const handle = getCollectionHandle(pathname);
    setCollectionCookie(handle);

    try {
      localStorage.setItem(STORAGE_KEY, collectionPath);
    } catch (_) {}
  }

  function removeVeil() {
    const veil = document.getElementById('redirect-veil');
    if (veil) veil.remove();
  }

  function updateContextIfOnCollection() {
    const currentPath = normalizePath(window.location.pathname);
    if (isCollectionPath(currentPath)) {
      setStoredCollectionPath(currentPath);
    }
  }

  function enforceContextRedirect() {
    const currentPath = normalizePath(window.location.pathname);
    const storedPath = normalizePath(getStoredCollectionPath());

    if (!storedPath || storedPath === '/') {
      removeVeil();
      return;
    }

    if (storedPath === currentPath) {
      removeVeil();
      return;
    }

    if (isAllowedPath(currentPath)) {
      removeVeil();
      return;
    }

    window.location.replace(storedPath);
  }

  function syncCollectionCookieFromStorage() {
    const storedPath = getStoredCollectionPath();
    if (!storedPath) return;
    setCollectionCookie(getCollectionHandle(storedPath));
  }

  function run() {
    updateContextIfOnCollection();
    syncCollectionCookieFromStorage();
    enforceContextRedirect();
  }

  run();
  window.addEventListener('pageshow', run);
})();